export default __webpack_public_path__ + "static/WideCard-da4139c0df28d7f98b7dd42920078d75.png";